import config from 'config';
import { isEmpty, isObject } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getCertForServer, getCertList } from 'services/crypto/crypto';
import SignService from 'services/sign';
import Vipnet from 'services/vipnet';
import oidMap from 'services/vipnet/oidMap';
import moment from 'utils/moment';
import Button from '../../../../components/Button';
import Field from '../../../../components/Field/index';
import Loading from '../../../../components/Loading/index';
import Modal from '../../../../components/Modal';
import RadioGroup from '../../../../components/RadioGroup';
import Select from '../../../../components/Select';
import questionBlockMap from '../../../Help/constants/questionBlockMap';
import { sendCertificate } from '../../services/API';
import CertificateInfo from './CertificateInfo';
import CheckCertificatePassword from './CheckCertificatePassword';
import getVipnetCertificateFields from './private/getVipnetCertificateFields';
import registrationErrorsMap from './private/registrationErrorsMap';
import {
  deleteCertificateStatusMessages,
  error,
  expired,
  INNER_SIGN,
  inProcess,
  ITEX_CERTIFICATE,
  NO_CERTIFICATE,
  QUAL_SING,
  registered,
  remove,
  removeForRegister,
  revoked,
  signOptions,
  statusMessages,
} from './private/signOptions';
import './private/styles.scss';
import { isMoment } from 'moment';
import { getDocumentTypes } from '../../../Taps/services/API/index';
import Warning from '../../../../components/Warning/index';
import errorMessages from '../../../../constants/errorMessages';
import RevokeVipnetSertificate from 'modules/Profile/components/Sign/VipnetRevokeForm';
import { remotePaths } from 'router/routes';

const CERT_INFO_ERROR = 'Произошла ошибка во время получения реквизитов сертификата';
const notFoundMessage = 'Не найдено ни одной квалифицированной подписи, доступной для регистрации';

const vipnet = new Vipnet();

export default class Sign extends Component {
  static propTypes = {
    certificateInfo: PropTypes.instanceOf(Map).isRequired,
    registrationStatus: PropTypes.instanceOf(Map).isRequired,
    inn: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    checkRemoving: PropTypes.instanceOf(Map).isRequired,
    personalData: PropTypes.instanceOf(Map).isRequired,
    contactInfo: PropTypes.instanceOf(Map).isRequired,
    checkStatus: PropTypes.func.isRequired,
    getCertificateInfo: PropTypes.func.isRequired,
    removeCertificate: PropTypes.func.isRequired,
    loadPersonalData: PropTypes.func.isRequired,
    resetCertificateRemoving: PropTypes.func.isRequired,
    goToProfilePage: PropTypes.func.isRequired,
  };

  state = {
    signOption: INNER_SIGN,
    certList: null,
    message: null,
    showErrors: false,
    status: null,
    password: '',
    controlPassword: '',
    tryingAgain: false,
    vipnetAvailable: false,
    vipnetCertificate: null,
    loading: false,
    cryptoProviderError: null,
    registrationError: null,
    registrationData: null,
    showModal: false,
    action: null,
    deletingType: null,
    afterDeleteAction: null,
    tapsIsAvailable: true,
    tapsLoading: false,
  };

  signService = null;

  componentDidMount() {
    const { personalData, checkStatus, loadPersonalData } = this.props;

    this.checkTaps();
    //always check the status on the entrance
    checkStatus();

    if (!personalData.get('data')) {
      loadPersonalData();
    }
  }

  /* фикс: теперь проверяем статус только после того как пришел ответ с запроса на регистрацию, а также сбрасываем попытку зарегаться снова
   * еще фикс : устанавливаем опцию по умолчанию если приходит статус зарегистрирован
   * фикс: проверка на наличие кэп, если ничего не зарегистрировано (по умолчанию кэп)*/
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { registrationStatus, inn } = nextProps;
    const statusObj = registrationStatus.get('data');
    const currentStatusObj = this.props.registrationStatus.get('data');
    const needGetCertList =
      statusObj &&
      statusObj.registrationStatus !== registered &&
      this.state.signOption === QUAL_SING;
    const needSetDefault =
      statusObj &&
      (!currentStatusObj || currentStatusObj.signatureType !== statusObj.signatureType);

    if (needSetDefault) {
      this.setState({
        signOption:
          statusObj.signatureType === NO_CERTIFICATE || !statusObj.signatureType
            ? INNER_SIGN
            : statusObj.signatureType,
      });
    } else if (needGetCertList) {
      this.getCertList();
    }
    if (inn !== this.props.inn) {
      this.checkVipnetRegistration(inn);
    }
  }

  checkTaps = () => {
    this.setState({
      tapsLoading: true,
      tapsIsAvailable: false,
    });
    getDocumentTypes()
      .then((response) => {
        if (!response.isOk) {
          throw response.error;
        }
        this.setState({
          tapsLoading: false,
          tapsIsAvailable: true,
        });
      })
      .catch(() => {
        this.setState({
          tapsLoading: false,
          tapsIsAvailable: false,
        });
      });
  };

  checkVipnetRegistration = (inn) => {
    this.setState({ loading: true });
    return vipnet
      .checkRegistration(inn)
      .then(() => vipnet.checkConnection())
      .then(() => {
        this.setState({ vipnetAvailable: true, loading: false });
      })
      .catch(() => {
        this.setState({ vipnetAvailable: false, loading: false });
      });
  };

  /*сразу проверяй, если переходишь в опцию регистрации кэп - загружаем сертификаты, если не зареган */
  changeSignOption(signOption) {
    const { inn } = this.props;
    this.setState({
      tryingAgain: false,
      registrationError: null,
      cryptoProviderError: null,
      message: '',
    });
    if (this.state.signOption !== signOption) {
      this.signService = null;
    }

    if (signOption === ITEX_CERTIFICATE && !this.state.vipnetAvailable) {
      return this.checkVipnetRegistration(inn).finally(() => {
        this.setState({ signOption, controlPassword: '', password: '' });
      });
    }

    this.setState({ signOption, controlPassword: '', password: '' });
    if (signOption === QUAL_SING && this.shouldLoadCertificationList()) {
      this.getCertList();
    }
  }

  /*если статус зарегистрирован и тип подписи кэп - то нет смысла загружать сертификаты*/
  shouldLoadCertificationList() {
    const statusObj = this.props.registrationStatus.get('data') || {};
    const isRegisteredQSS =
      statusObj.registrationStatus === registered &&
      statusObj.signatureType &&
      QUAL_SING === statusObj.signatureType;
    return !isRegisteredQSS;
  }

  /*если только один сертификат, то сразу его устанавливаем*/
  getCertList() {
    getCertList()
      .then((list) => {
        if (list.length === 1) {
          this.setState({ certificate: list[0].value, certList: list });
        } else {
          this.setState({ certList: list });
        }
      })
      .catch(() => {
        this.setState({ message: notFoundMessage });
      });
  }

  getSignService = () => {
    if (!this.signService) {
      const { certificate, signOption } = this.state;
      this.signService = new SignService({
        certificateHash: certificate,
        signatureType: signOption,
      });
    }
    return this.signService;
  };

  async isValidCertificate() {
    if (!config.isValidateCertificate) {
      return true;
    }
    const signService = this.getSignService();

    return await signService.checkCertificate(this.props.inn);
  }

  /*регистрация КЭП : необязательна кодировка!*/
  registerCertificate = () => {
    if (this.state.certificate) {
      this.isValidCertificate()
        .then(() => {
          if (this.state.signOption === ITEX_CERTIFICATE) {
            return this.state.certificate;
          }
          return getCertForServer(this.state.certificate);
        })
        .then((result) => {
          this.sendCertificateRequest({ certificate: result, origin: this.state.signOption });
        })
        .catch((error) => {
          this.setState({
            message: error.friendlyErrorMessage || null,
            cryptoProviderError: error,
            loading: false,
            tryingAgain: false,
          });
        });
    }

    if (this.state.certificateRequest && this.state.signOption === ITEX_CERTIFICATE) {
      this.sendCertificateRequest({ certificateRequest: this.state.certificateRequest });
    }
  };

  /*регистрация НЭП : повторно проверяем статус после отправки запроса на регистрацию */
  generateInnerCertificate(e) {
    if (e) {
      e.preventDefault();
    }
    if (isEmpty(this.getValidationObject())) {
      this.processRegistration();
    } else {
      this.setState({ showErrors: true, password: '', controlPassword: '' });
    }
  }

  registerDSSCertificate = () => {
    this.sendCertificateRequest({ pin: this.state.password });
    this.setState({ showErrors: false, password: '', controlPassword: '' });
  };

  sendCertificateRequest = (requestData) => {
    this.setState({
      loading: true,
      registrationError: null,
      registrationData: null,
    });

    sendCertificate(requestData)
      .then((response) => {
        const data = response.data || {};
        const hasError =
          data.registrationStatus === error ||
          data.registrationStatus === expired ||
          !response.isOk;
        if (hasError) {
          throw response.error || data.errorMessage || data.registrationStatus;
        }

        return data;
      })
      .then((responseData) => {
        this.props.checkStatus();
        this.setState(
          {
            loading: false,
            registrationData: responseData,
            tryingAgain: false,
          },
          () => {
            if (responseData.certificate) {
              this.installCertificate(responseData.certificate);
            }
          },
        );
      })
      .catch((error) => {
        this.setState({
          loading: false,
          registrationError: error,
          tryingAgain: false,
          message: this.getErrorMessage(error),
        });
      });
  };

  getErrorMessage = (error) => {
    let registrationError = registrationErrorsMap[error];

    if (isObject(registrationError)) {
      registrationError = registrationError[this.state.signOption] || null;
    }

    return registrationError;
  };

  installCertificate = (certificate) => {
    vipnet.installCertificate(certificate).catch((error) => {
      this.setState({
        message: statusMessages[ITEX_CERTIFICATE].error,
        cryptoProviderError: error,
        loading: false,
        tryingAgain: false,
      });
    });
  };

  setValue(target, value) {
    this.setState({ [target]: value.target.value });
  }

  getValidationObject = () => {
    const { password, controlPassword } = this.state;
    let validationObject = {};

    if (password !== controlPassword) {
      validationObject.controlPassword = {
        isValid: false,
        validationMessage: 'Пароль и подтверждение пароля не совпадают',
      };
    }
    if (!password) {
      validationObject.password = {
        isValid: false,
        validationMessage: 'Не заполнено обязательное поле',
      };
    }
    if (password.length < 6) {
      validationObject.password = {
        isValid: false,
        validationMessage: 'Пароль должен иметь длину не менее 6 символов',
      };
    }
    const check1 = password.search(/[A-Z]/) === -1;
    const check2 = password.search(/[a-z]/) === -1;
    const check3 = password.search(/[0-9]/) === -1;

    if (check1 || check2 || check3) {
      validationObject.password = {
        isValid: false,
        validationMessage: (
          <div>
            <div className="link">Пароль должен содержать:</div>
            <ul className="list list__dark profile_list">
              {check1 ? <li>Прописные латинские буквы (A-Z)</li> : null}
              {check2 ? <li>Строчные латинские буквы (a-z)</li> : null}
              {check3 ? <li>Цифры (0-9)</li> : null}
            </ul>
          </div>
        ),
      };
    }
    return validationObject;
  };

  getInProcessStatusBlock(signType) {
    return (
      <div className="blue-block blue-block__pad40">
        <h4 className="page_margin30">Генерация электронной подписи</h4>
        <div className="link link_load page_margin40">{statusMessages[signType][inProcess]}</div>
      </div>
    );
  }

  getDateFormat(value) {
    if (isMoment(value)) {
      return value.defaultFormat();
    }
    return moment(value).defaultFormat();
  }

  successRegisteredBlock(signatureType) {
    const { registrationStatus } = this.props;
    const { startCertificateDate, endCertificateDate } = registrationStatus.get('data');
    return (
      <div className="green-block green-block__pad40">
        {statusMessages[signatureType][registered]}
        {!config.isInspectorArm && signatureType === QUAL_SING ? (
          <Button
            onClick={(e) => this.tryAgain(e)}
            value="Зарегистрировать другой сертификат"
            hasWrapper={false}
            size="medium"
            color="orange"
          />
        ) : null}
        {signatureType === INNER_SIGN ? (
          <div className="link link_attention page_margin30 page_margin40">
            Теперь Вы можете подписывать и направлять в налоговый орган декларации, заявления и иные
            документы.
          </div>
        ) : null}

        {startCertificateDate && endCertificateDate ? (
          <div className="bold" style={{ paddingLeft: '30px' }}>
            <div className="cRow page_margin20">
              <div className="cCol">
                Дата выпуска сертификата: {this.getDateFormat(startCertificateDate)}
              </div>
            </div>
            <div className="cRow page_margin20">
              <div className="cCol">
                Дата окончания действия сертификата: {this.getDateFormat(endCertificateDate)}
              </div>
            </div>
          </div>
        ) : null}
        {config.isInspectorArm ? null : (
          <div className="cRow" style={{ paddingTop: '30px' }}>
            <div className="cCol cCol__inline">
              <a
                className="link link__20 page_margin30"
                onClick={() => this.viewCertificate('view')}
              >
                Просмотреть сертификат
              </a>
            </div>
            <div className="cCol cCol__inline">
              <a
                className="link link__20 page_margin30"
                onClick={() => this.viewCertificate(remove)}
              >
                {signatureType === QUAL_SING ? 'Удалить сертификат' : 'Отозвать сертификат'}
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }

  /*если приходит статус отличный от регистеред и инпроцесс - показывай это*/
  getNotRegisteredBlock() {
    switch (this.state.signOption) {
      case QUAL_SING:
        return this.renderCertList();
      case INNER_SIGN:
        return this.notRegisteredDss();
      case ITEX_CERTIFICATE:
        return this.registerITEXForm();
    }
  }

  registerITEXForm = () => {
    const { personalData, inn } = this.props;
    const data = personalData.get('data') || {};
    const fields = getVipnetCertificateFields(Object.assign({}, data, { inn }));

    if (!this.state.vipnetAvailable) {
      return (
        <div>
          На Вашем компьютере не установлены необходимые средства электронной подписи (для ОС
          Microsoft Windows -&nbsp;
          <a href="https://lkfl2.nalog.ru/lkfl/download/setup.exe">скачать</a>, для ОС Mac OS
          -&nbsp;
          <a href="https://lkfl2.nalog.ru/lkfl/download/setup.dmg">скачать</a>).
        </div>
      );
    }

    return (
      <div>
        <h4 className="page_margin30">Реквизиты сертификата</h4>
        {fields.map((field, key) => {
          return (
            <div key={`cert_data_${key}`} className="profile_item text-big">
              <div className="cRow">
                <div className="cCol cCol__50 grey">{field.title}</div>
                <div className="cCol cCol__50">{field.value}</div>
              </div>
            </div>
          );
        })}
        <div className="cRow">
          <div className="cCol">
            <Button
              onClick={() => this.processRegistration()}
              color="orange"
              size="medium"
              hasWrapper={false}
              value="Отправить запрос"
              isDisabled={config.isInspectorArm}
            />
          </div>
          <div className="cCol">
            <Button
              onClick={() => this.processRegistration(true)}
              color="blue"
              size="medium"
              hasWrapper={false}
              value="Зарегистрировать имеющийся сертификат"
              isDisabled={config.isInspectorArm}
            />
          </div>
        </div>
      </div>
    );
  };

  generateSubjectString = () => {
    const { personalData, inn, email } = this.props;
    const data = personalData.get('data') || {};
    const snils = (data.snils || '').replace(/[\-\s]/gi, '');
    const fields = {
      name: `OID.${oidMap.givenName}="${data.firstName} ${data.lastName}";`,
      snils: snils ? `OID.${oidMap.SNILS}="${snils}";` : '',
      countryName: `OID.${oidMap.countryName}="RU";`,
      email: `OID.${oidMap.emailAddress}="${email}";`,
      fullName: `OID.${oidMap.commonName}="${data.lastName} ${data.firstName} ${
        data.middleName || ''
      }";`,
      innField: `OID.${oidMap.INN}="${inn}";`,
      surname: `OID.${oidMap.surname}="${data.lastName}";`,
      address: `OID.${oidMap.registeredAddress}="${data.residenceAddress}"`,
    };

    return Object.values(fields).join('');
  };

  registerExistingITEXCertificate = () => {
    this.setState({
      loading: true,
      certificate: null,
      tryingAgain: false,
    });

    const signService = this.getSignService();
    signService.clearCertificateCache();
    signService
      .getVipnetCertificate(true)
      .then((certificate = {}) => {
        //loading stopped in registerCertificate function
        signService.setOptions({
          certificateHash: certificate.value,
          signatureType: ITEX_CERTIFICATE,
        });

        this.setState(
          {
            certificate: certificate.Base64RawData,
            certificateRequest: null,
            signatureType: ITEX_CERTIFICATE,
          },
          () => this.registerCertificate(),
        );
      })
      .catch((error) => {
        this.setState({
          message: statusMessages[ITEX_CERTIFICATE].error,
          cryptoProviderError: error,
          loading: false,
        });
      });
  };

  registerITEXCertificate = () => {
    const subject = this.generateSubjectString();

    this.setState({
      loading: true,
    });

    vipnet
      .generateCertificate(subject)
      .then((certificateRequest) => {
        this.setState(
          {
            certificate: null,
            certificateRequest,
            signatureType: ITEX_CERTIFICATE,
            loading: false,
          },
          () => this.registerCertificate(),
        );
      })
      .catch((error) => {
        this.setState({
          message: statusMessages[ITEX_CERTIFICATE].error,
          cryptoProviderError: error,
          loading: false,
        });
      });
  };

  processRegistration = (existing) => {
    const { registrationStatus } = this.props;
    const data = registrationStatus.get('data') || {};
    const registrationFunction = () =>
      this.getRegistrationFunction(this.state.signOption, existing)();

    if (data.signatureType === this.state.signOption || data.registrationStatus !== registered) {
      return registrationFunction();
    }

    this.setState({
      showModal: true,
      deletingType: data.signatureType,
      afterDeleteAction: registrationFunction,
      action: remove,
    });
  };

  getRegistrationFunction = (type, existing) => {
    switch (type) {
      case QUAL_SING:
        return this.registerCertificate;
      case ITEX_CERTIFICATE:
        return existing ? this.registerExistingITEXCertificate : this.registerITEXCertificate;
      case INNER_SIGN:
        return this.registerDSSCertificate;
    }
  };

  /* НЭП :  статус отличный от регистеред и инпроцесс*/

  /*добавить обработку на тот случай если пользователь сразу перешел на страницу эп, т е персональных данных еще нет в сторе(решениеЖ сразу вытаскиваем инн в сторе)*/
  notRegisteredDss() {
    const { showErrors, password, controlPassword } = this.state;
    const { personalData, inn, email } = this.props;
    const validation = showErrors ? this.getValidationObject() : {};
    const className = 'cCol cCol__33 form_item';
    const data = personalData.get('data') || {};
    const fields = getVipnetCertificateFields(Object.assign({}, data, { inn, email }));
    return (
      <div>
        <h4 className="page_margin30">Реквизиты сертификата</h4>
        {fields.map((field, key) => {
          return (
            <div key={`cert_data_${key}`} className="profile_item text-big">
              <div className="cRow">
                <div className="cCol cCol__50 grey">{field.title}</div>
                <div className="cCol cCol__50">{field.value}</div>
              </div>
            </div>
          );
        })}
        <h4 className="page_margin20">Доступ к сертификату по подписи</h4>
        <form className="form">
          <div className="profile_top">
            <div className="cRow">
              <Field
                onChange={(e) => this.setValue('password', e)}
                isRequired={true}
                label="Установите пароль для доступа"
                value={password}
                type="password"
                {...validation.password}
                key="password"
                isDisabled={config.isInspectorArm}
                className={className}
                maxLength={255}
              />
              <Field
                onChange={(e) => this.setValue('controlPassword', e)}
                isRequired={true}
                label="Введите пароль еще раз"
                value={controlPassword}
                type="password"
                key="controlPassword"
                {...validation.controlPassword}
                isDisabled={config.isInspectorArm}
                className={className}
                maxLength={255}
              />
            </div>
            {this.renderGenerateButton(
              this.generateInnerCertificate.bind(this),
              'Отправить запрос',
            )}
          </div>
        </form>
      </div>
    );
  }

  selectCertificate({ value: certificate }) {
    this.setState({ certificate });
  }

  /*пусть повторно проверяет наличие кэп (пользователь мог увидеть что у него нет ни одного сертификата, зарегистрировать, затем нажать на кнопку)*/
  tryAgain(e) {
    e.preventDefault();
    this.setState({ tryingAgain: true, showErrors: false, message: '', cryptoProviderError: null });
    if (this.state.signOption === QUAL_SING && !this.state.certList) {
      this.getCertList();
    }
  }

  registerAnotherCertificate(e) {
    this.tryAgain(e);
  }

  //статус в процесее - ВСЕГДА той подписи, которая регистрируется
  // и по договоренности с беком в данном кейсе ВСЕГДА приходит тип подписи

  /*
  outer sign пока не реализован, только статичный текст,
  при запросе статуса приходит обьект типа {signatureType : нэп/нэп, статус}
  если статус зарегистрирован - смотрим на тип,
  если статус в процессе - отображаем для всех опций блок в процессе,
  */

  /*проблема : статус - зарегистрирован КЭП, хотим зарегистрировать НЭП отправили запрос на регистрацию - статус не обновился
   * обсуди с Мигой
   * если прилетела ошибка - смотрим нажимал ли пользователь кнопку попробовать снова, если да то отображаем страницу регистрации
   * */
  getStatusMessage() {
    const signStatus = this.props.registrationStatus.get('data');

    if (!signStatus) {
      return null;
    }

    const { tryingAgain, signOption } = this.state;
    const currentSign = this.getSignType();
    const isNotRegistered =
      signStatus.registrationStatus !== inProcess && (tryingAgain || signOption !== currentSign);

    if (isNotRegistered) {
      return this.getNotRegisteredBlock();
    }

    switch (signStatus.registrationStatus) {
      case inProcess:
        return this.getInProcessStatusBlock(currentSign);
      case registered:
        return this.successRegisteredBlock(currentSign);
      case error:
        return this.renderErrorMessage();
      default:
        return this.getNotRegisteredBlock();
    }
  }

  /* может отловиться ошибка во время запроса- обработали
  может придти статус error при 200 ответе - обработали
  может придти статус неправильный пин - обработали
  может придти статус wrong_pin при кэп- отработали (маловероятно)
  */
  showCertInfo() {
    const { certificateInfo } = this.props;
    const { signOption } = this.state;
    if (certificateInfo.get('error')) {
      return this.renderErrorMessage(CERT_INFO_ERROR, false);
    } else if (certificateInfo.get('loading')) {
      return this.renderLoading();
    } else if (certificateInfo.get('data')) {
      const { status } = certificateInfo.get('data');
      switch (status) {
        case 'WRONG_PIN':
          return signOption === INNER_SIGN ? (
            <CheckCertificatePassword
              invalidStatus={true}
              removeCertificate={this.deleteCert}
              checkPassword={(password) => this.checkCertPassword(password)}
            />
          ) : (
            this.renderErrorMessage(CERT_INFO_ERROR, false)
          );
        case 'OK':
          return <CertificateInfo certificateInfo={certificateInfo} signType={signOption} />;
        case 'ERROR':
          return this.renderErrorMessage(CERT_INFO_ERROR, false);
      }
    } else {
      /*если нет реквизитов сертификата возможно два варианта : 1) нэп - тогда отображаем поле с паролем
      2) кэп - тогда крутилка*/
      return signOption === INNER_SIGN ? (
        <CheckCertificatePassword
          removeCertificate={() => this.deleteCert()}
          checkPassword={(password) => this.checkCertPassword(password)}
        />
      ) : (
        this.renderLoading()
      );
    }
  }

  revokeItexCertificate = (immutableData, type) => {
    const { reason, description, certificateRequest } = immutableData.toJS();
    const requestData = {
      description,
      reason,
      certificateRequest,
    };
    this.certificateRemovingBlock(type, requestData);
  };

  deleteCert = () => {
    const { signOption, deletingType, vipnetRevoke } = this.state;
    const { checkRemoving } = this.props;
    const type = deletingType || signOption;
    if (checkRemoving.get('error')) {
      return (
        <div>
          <p className="text-big">{deleteCertificateStatusMessages[type][error]}</p>
        </div>
      );
    }
    if (checkRemoving.get('loading')) {
      return <div>{this.renderLoading()}</div>;
    }
    if (checkRemoving.get('data')) {
      return (
        <div>
          <p className="text-big">{deleteCertificateStatusMessages[type][revoked]}</p>
        </div>
      );
    }
    const style = { marginRight: '30px' };
    const action = deletingType ? removeForRegister : remove;
    const content = deleteCertificateStatusMessages[type][action];
    let okLabel = 'ОК';
    if (deletingType) {
      okLabel = type === QUAL_SING ? 'Удалить' : 'Отозвать';
    }
    if (vipnetRevoke) {
      return (
        <RevokeVipnetSertificate
          onClose={() => {
            this.setState({ vipnetRevoke: false });
            this.close(true);
          }}
          onSubmit={(data) => this.revokeItexCertificate(data, type)}
        />
      );
    }
    return (
      <div>
        <p className="text-big">{content}</p>
        <div className="buttons_right">
          <Button style={style} onClick={() => this.close(true)} value="Отмена" />
          <Button
            style={style}
            onClick={() =>
              type !== ITEX_CERTIFICATE
                ? this.certificateRemovingBlock(type)
                : this.setState({
                    vipnetRevoke: true,
                  })
            }
            value={okLabel}
          />
        </div>
      </div>
    );
  };

  certificateRemovingBlock = (type, requestData) => {
    this.props.removeCertificate(deleteCertificateStatusMessages[type]['url'], requestData);
  };

  checkCertPassword(pin) {
    this.props.getCertificateInfo({ pin, signatureType: this.state.signOption });
  }

  close(ignoreAction) {
    const { checkRemoving, checkStatus, resetCertificateRemoving } = this.props;
    const { afterDeleteAction } = this.state;
    if (checkRemoving.get('data')) {
      checkStatus();
      resetCertificateRemoving();

      if (afterDeleteAction && !ignoreAction) {
        afterDeleteAction();
        this.setState({
          deletingType: null,
          afterDeleteAction: null,
        });
      }
    }
    this.setState({ showModal: false, action: null });
  }

  //если у нас кэп - сразу шлем запрос на сервер, тк пароль не нужен
  viewCertificate(action) {
    const { signOption } = this.state;
    const { getCertificateInfo } = this.props;
    if (signOption !== INNER_SIGN) {
      getCertificateInfo({ signatureType: signOption });
    }
    this.setState({ showModal: true, action });
  }

  getRadioGroupItems() {
    const { registrationStatus: status } = this.props;
    const { loading } = this.state;
    const isLoading = status.get('loading') || loading;
    const isInProcess = status.get('data') && status.get('data').registrationStatus === inProcess;
    return signOptions.map((option) =>
      Object.assign(
        {},
        {
          isDisabled: option.value !== this.state.signOption && (isLoading || isInProcess),
        },
        option,
      ),
    );
  }

  getSignType() {
    const statusObj = this.props.registrationStatus.get('data');
    if (statusObj && statusObj.signatureType) {
      return statusObj.signatureType;
    }
    return false;
  }

  /*КЭП : список сертификатов надо дизайблить если мы уже нажали на кнопку и запросили регистрацию*/
  renderCertList() {
    const { certList, message, certificate } = this.state;
    if (message) {
      return this.renderErrorMessage();
    } else if (certList === null) {
      return this.renderLoading();
    } else {
      if (certList.length) {
        return (
          <div>
            <div className="page_margin20">
              <Select
                options={certList.map((cert) => ({
                  label: `CN=<${cert.CN}> Выдан :${moment(cert.ValidFromDate).defaultFullFormat()}`,
                  value: cert.value,
                }))}
                isFull={true}
                placeholder="Выберите сертификат для регистрации"
                value={certificate}
                isDisabled={config.isInspectorArm}
                onChange={(value) => this.selectCertificate(value)}
              />
            </div>
            {this.renderGenerateButton(this.processRegistration, 'Зарегистрировать сертификат ЭП')}
          </div>
        );
      } else {
        return <span>Не найден ни один сертификат</span>;
      }
    }
  }

  renderErrorMessage(message = this.state.message, hasButton = true) {
    const { certList, signOption } = this.state;
    const againButton = (
      <Button
        onClick={(e) => this.tryAgain(e)}
        isDisabled={config.isInspectorArm}
        value="Попробовать еще раз"
        size="medium"
        hasWrapper={false}
      />
    );
    const registerOtherButton = (
      <Button
        onClick={(e) => this.registerAnotherCertificate(e)}
        isDisabled={config.isInspectorArm}
        value="Зарегистрировать другой сертификат"
        hasWrapper={false}
        size="medium"
      />
    );
    return (
      <div className="blue-block blue-block__pad40">
        <h4 className="page_margin30">{message ? message : statusMessages[INNER_SIGN][error]}</h4>
        {hasButton ? (
          signOption === QUAL_SING ? (
            <div className="form_buttons">
              {againButton}
              {certList !== null && certList.length ? registerOtherButton : null}
            </div>
          ) : (
            againButton
          )
        ) : null}
      </div>
    );
  }

  renderGenerateButton(onClick, value) {
    return (
      <div className="cRow">
        <div className="cCol form_item">
          <Button
            onClick={(e) => onClick(e)}
            value={value}
            color="orange"
            type="button"
            isDisabled={config.isInspectorArm}
            size="medium"
          />
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="loading-container loading-container__middle">
        <Loading />
      </div>
    );
  }

  renderTab() {
    const { registrationStatus: status, personalData, checkRemoving } = this.props;
    const { signOption, showModal, action, loading, cryptoProviderError, registrationError } =
      this.state;
    const isLoading = status.get('loading') || personalData.get('loading') || loading;
    const removeLoading = checkRemoving.get('loading');

    return (
      <div className={'white-block__pad40 pt-0'}>
        <div className="page_margin20">
          Создайте новую облачную электронную подпись (неквалифицированную) или подключите
          имеющуюся, выданную
          <a
            target="_blank"
            href="https://digital.gov.ru/ru/activity/govservices/certification_authority/"
          >
            {' '}
            Удостоверяющим центром, аккредитованным Минцифры России (квалифицированную).
          </a>
        </div>
        <div className="page_margin40">
          <a
            href={{
              pathname: remotePaths.help,
              query: {
                scrollTo: questionBlockMap.certificate,
              },
            }}
            className="link link_question link__20"
          >
            Помощь по использованию электронной подписи
          </a>
        </div>
        <h4 className="page_margin30">Выберите вариант хранения электронной подписи</h4>

        <RadioGroup
          onChange={(option) => this.changeSignOption(option)}
          hasWrapper={true}
          items={this.getRadioGroupItems()}
          isDisabled={config.isInspectorArm}
          name="sign"
          selectedValue={signOption}
        />
        {isLoading
          ? this.renderLoading()
          : (registrationError || status.get('error') || cryptoProviderError) &&
            !this.state.tryingAgain
          ? this.renderErrorMessage()
          : this.getStatusMessage()}
        <Modal onClose={() => !removeLoading && this.close()} showModal={showModal} type="large">
          {action === remove ? this.deleteCert() : this.showCertInfo()}
        </Modal>
      </div>
    );
  }

  render() {
    const { tapsIsAvailable, tapsLoading } = this.state;

    if (tapsLoading) {
      return this.renderLoading();
    }

    if (!tapsIsAvailable) {
      return <Warning message={errorMessages.serviceIsUnavailable} />;
    }

    return this.renderTab();
  }
}
